var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "px-1 sm:px-12 py-8 font-outfit flex-1" }, [
    _c(
      "div",
      {
        staticClass:
          "flex justify-between items-center mb-4 pb-4 borderMainClientProfile",
      },
      [
        _c("h2", { staticClass: "text-lg font-normal" }, [
          _vm._v("Basic Information"),
        ]),
        _c(
          "button",
          {
            staticClass:
              "px-8 py-2 text-16 rounded-full border border-secondary-black hover:bg-gray-50 focus:outline-none",
            on: {
              click: function ($event) {
                return _vm.$emit("edit")
              },
            },
          },
          [_vm._v(" Edit ")]
        ),
      ]
    ),
    _c("div", { staticClass: "flex flex-col gap-5" }, [
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Full Name"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(_vm._s(_vm.getFullName(_vm.data))),
        ]),
      ]),
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Preferred Name"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(
            _vm._s(_vm.data.preferred_name ? _vm.data.preferred_name : "N/A")
          ),
        ]),
      ]),
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Client ID"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(_vm._s(_vm.data.client_id ? _vm.data.client_id : "N/A")),
        ]),
      ]),
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Date of Birth"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(_vm._s(_vm.formmatedDate(_vm.data.dob))),
        ]),
      ]),
      _c("div", { staticClass: "flex gap-8" }, [
        _vm._m(0),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(_vm._s(_vm.data.gender ? _vm.data.gender : "N/A")),
        ]),
      ]),
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Address"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(_vm._s(_vm.data.address ? _vm.data.address : "N/A")),
        ]),
      ]),
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Date Started"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(_vm._s(_vm.formmatedDate(_vm.data.created_at))),
        ]),
      ]),
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Date Completed"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(_vm._s(_vm.formmatedDate(_vm.data.date_completed))),
        ]),
      ]),
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Phone Number"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(_vm._s(_vm.data.phone_number)),
        ]),
      ]),
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Email Address"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(
            _vm._s(_vm.data.email_address ? _vm.data.email_address : "N/A")
          ),
        ]),
      ]),
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "text-16 font-medium minWContent mb-2" }, [
          _vm._v("Tags"),
        ]),
        _vm.data.project_skills?.length > 0
          ? _c(
              "div",
              { staticClass: "flex flex-row gap-1 items-center" },
              [
                _vm._l(_vm.data?.project_skills?.slice(0, 3), function (skill) {
                  return _c(
                    "div",
                    { key: skill.skill.name, staticClass: "skills-chip" },
                    [_vm._v(" " + _vm._s(skill.skill.name) + " ")]
                  )
                }),
                _vm.data.project_skills?.length > 3
                  ? _c(
                      "div",
                      { staticClass: "cursor-default hover:!cursor-pointer" },
                      [
                        _c(
                          "RouterLink",
                          { attrs: { to: _vm.detailsPageRoute } },
                          [
                            _c("p", { staticClass: "skills-chip-plus" }, [
                              _vm._v(
                                " +" +
                                  _vm._s(_vm.data?.project_skills?.length - 3) +
                                  " "
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
        _vm.data?.project_skills?.length === 0 ||
        _vm.data?.project_skills === undefined
          ? _c("div", { staticClass: "flex items-center text-base" }, [
              _vm._v(" N/A "),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "flex-1 text-16 font-medium minWContent" },
      [
        _vm._v("Gender "),
        _c("span", { staticClass: "text-gray-400" }, [_vm._v("(optional)")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }